export class UpdateWorkTypeGroupError extends Error {

}
